export default "__VITE_ASSET__BzCyixIl__"